import { types } from "mobx-state-tree"

export const UpdatePassword = types
    .model("UpdatePassword", {
        current_user_password: "",
        new_password: "",
        new_password_confirmation: "",
    })